<div class="futuristic-login-container">
  <!-- Partículas de fondo animadas -->
  <div class="particles-background">
    <div class="particle" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]" 
         [style.left.%]="(i * 7) % 100" 
         [style.animation-delay.s]="i * 0.3"
         [style.animation-duration.s]="4 + (i % 3) * 2"></div>
  </div>

  <!-- Contenedor principal -->
  <div class="login-main-container">
    
    <!-- Lado izquierdo - Formulario -->
    <div class="login-form-section">
      <div class="form-container">
        
        <!-- Logo y header -->
        <div class="logo-section">
          <div class="logo-container">
            <div class="logo-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>
            <span class="logo-text">SecureAccess</span>
          </div>
        </div>

        <!-- Header del formulario -->
        <div class="form-header">
          <h1 class="form-title">Bienvenido de vuelta</h1>
          <p class="form-subtitle">Ingresa a tu cuenta para continuar</p>
        </div>

        <!-- Formulario -->
        <form class="login-form" [formGroup]="form" (ngSubmit)="form.valid && onSubmit()" autocomplete="off">
          
          <!-- Campo Email -->
          <div class="input-group" [ngClass]="{'is-invalid': form.get('email').touched && form.get('email').invalid}">
            <label for="email" class="input-label">Correo electrónico</label>
            <div class="input-container">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <input 
                type="email" 
                id="email" 
                name="email"
                class="input-field" 
                formControlName="email"
                placeholder="usuario@empresa.com"
                autocomplete="new-password"
                value="user@email.com"
              />
            </div>
            <div *ngIf="form.get('email').touched && form.get('email').invalid" class="error-message">
              <div *ngIf="form.get('email').errors?.required">El campo correo electrónico es requerido</div>
              <div *ngIf="form.get('email').errors?.email">El correo electrónico debe ser un formato válido</div>
            </div>
          </div>

          <!-- Campo Contraseña -->
          <div class="input-group" [ngClass]="{'is-invalid': form.get('password').touched && form.get('password').invalid}">
            <label for="password" class="input-label">Contraseña</label>
            <div class="input-container">
              <div class="input-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <circle cx="12" cy="16" r="1"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <input 
                [type]="passwordVisible ? 'text' : 'password'" 
                id="password" 
                name="password"
                class="input-field" 
                formControlName="password"
                placeholder="••••••••••••"
                maxlength="11"
                value="secret"
              />
              <button 
                type="button" 
                class="password-toggle"
                (click)="togglePasswordVisibility()" 
                aria-label="Mostrar u ocultar contraseña"
              >
                <svg *ngIf="!passwordVisible" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg *ngIf="passwordVisible" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
            </div>
            <div *ngIf="form.get('password').touched && form.get('password').invalid" class="error-message">
              <div *ngIf="form.get('password').errors?.required">La contraseña es requerida</div>
              <div *ngIf="form.get('password').errors?.minlength">Su contraseña no puede ser menor a 6 caracteres</div>
              <div *ngIf="form.get('password').errors?.maxlength">Su contraseña no puede ser mayor a 10 caracteres</div>
            </div>
          </div>

          <!-- Mensaje de error general -->
          <div *ngIf="errorMessage" class="error-message-general">
            {{ errorMessage }}
          </div>

          <!-- Botón de login -->
          <button 
            *ngIf="!isSubmited" 
            type="submit" 
            class="login-button"
            [disabled]="!form.valid"
          >
            <span class="button-text">Iniciar Sesión</span>
            <div class="button-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                <polyline points="10,17 15,12 10,7"/>
                <line x1="15" y1="12" x2="3" y2="12"/>
              </svg>
            </div>
          </button>

                     <!-- Loading spinner -->
           <div *ngIf="isSubmited" class="loading-spinner">
             <div class="spinner">
               <div class="spinner-bar"></div>
               <div class="spinner-bar"></div>
               <div class="spinner-bar"></div>
               <div class="spinner-bar"></div>
               <div class="spinner-bar"></div>
             </div>
             <span>Iniciando sesión...</span>
           </div>

        </form>
      </div>
    </div>

    <!-- Lado derecho - Visual -->
    <div class="visual-section">
      <div class="visual-content">
        <div class="floating-elements">
          <div class="floating-orb orb-1"></div>
          <div class="floating-orb orb-2"></div>
          <div class="floating-orb orb-3"></div>
          <div class="floating-orb orb-4"></div>
        </div>
        <div class="connection-lines">
          <svg class="connections-svg" viewBox="0 0 400 600">
            <defs>
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#0ea5e9;stop-opacity:0.8" />
                <stop offset="100%" style="stop-color:#3b82f6;stop-opacity:0.3" />
              </linearGradient>
            </defs>
            <path class="connection-line line-1" d="M50,100 Q200,150 350,200" stroke="url(#lineGradient)" fill="none" stroke-width="2"/>
            <path class="connection-line line-2" d="M100,300 Q250,250 300,400" stroke="url(#lineGradient)" fill="none" stroke-width="2"/>
            <path class="connection-line line-3" d="M80,450 Q200,350 320,500" stroke="url(#lineGradient)" fill="none" stroke-width="2"/>
          </svg>
        </div>
        <div class="central-content">
          <div class="logo-large">
            <img src="assets/images/logologin.png" alt="Logo" />
          </div>
          <h2 class="visual-title">La cultura de la prevención legal llevada a lo digital</h2>
                              
          <!-- Lista dinámica de módulos del sistema -->
          <div class="modules-showcase">
            <div class="module-display">
              <div class="module-icon">{{ currentModule.icon }}</div>
              <div class="module-info">
                <h3 class="module-name">{{ currentModule.name }}</h3>
                <p class="module-description">{{ currentModule.description }}</p>
              </div>
            </div>
            
            <!-- Indicadores de módulos -->
            <div class="module-indicators">
              <div 
                *ngFor="let module of systemModules; let i = index" 
                class="module-dot"
                [class.active]="i === currentModuleIndex"
                [class.next]="i === (currentModuleIndex + 1) % systemModules.length"
              ></div>
            </div>
            
            <!-- Contador de módulos -->
            <div class="module-counter">
              <span class="current-number">{{ currentModuleIndex + 1 }}</span>
              <span class="total-separator">/</span>
              <span class="total-number">{{ systemModules.length }}</span>
            </div>
          </div>
          
          <!-- Lista completa de funcionalidades 
          <div class="features-list">
            <div class="feature-item">
              <div class="feature-dot"></div>
              <span>Autenticación multifactor empresarial</span>
            </div>
            <div class="feature-item">
              <div class="feature-dot"></div>
              <span>Cumplimiento SOC 2 y ISO 27001</span>
            </div>
            <div class="feature-item">
              <div class="feature-dot"></div>
              <span>Encriptación de datos de nivel bancario</span>
            </div>
          </div>-->
        </div>
      </div>
    </div>

  </div>
</div>
